import { render } from "./OrderList.vue?vue&type=template&id=474c6c91&scoped=true&ts=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"

import "./OrderList.vue?vue&type=style&index=0&id=474c6c91&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474c6c91"]])

export default __exports__